import { Facebook } from "lucide-react";
import { LOGO_URL } from "@/lib/pricing";
import { scrollToId } from "@/lib/scroll";

const TikTokIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 1 1-2.31-2.83v-3.5a6.37 6.37 0 1 0 5.76 6.33V7.67a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.9Z" />
  </svg>
);

const SOCIALS = [
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@makiesmkreations?_r=1&_t=ZP-9AHDIv3NMtS",
    Icon: TikTokIcon,
    testid: "social-tiktok-link",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/share/1D8vJhArsP/?mibextid=wwXIfr",
    Icon: Facebook,
    testid: "social-facebook-link",
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#141D19] py-16 text-[#FDFBF7]" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-5 sm:flex-row sm:items-center lg:px-10">
        <div className="flex items-center gap-4">
          <img
            src={LOGO_URL}
            alt="Makie's Majestic Kreations logo"
            className="h-14 w-14 rounded-full object-cover ring-1 ring-[#D4AF37]/50"
          />
          <div>
            <p className="ff-serif text-2xl italic">Makie&rsquo;s Majestic Kreations</p>
            <p className="ff-script mt-1 text-lg text-[#D4AF37]">Crafting Dreams, One Creation at a Time</p>
            <div className="mt-3 flex items-center gap-3">
              {SOCIALS.map(({ name, href, Icon, testid }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Follow on ${name}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-[#D4AF37]/40 text-[#D4AF37] transition-colors hover:border-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#141D19]"
                  data-testid={testid}
                >
                  <Icon size={16} />
                </a>
              ))}
              <span className="text-[10px] uppercase tracking-[0.26em] text-[#FDFBF7]/45">
                Follow the Kreations
              </span>
            </div>
          </div>
        </div>
        <div className="text-left sm:text-right">
          <button
            onClick={() => scrollToId("#order")}
            className="text-[11px] uppercase tracking-[0.26em] text-[#D4AF37] transition-colors hover:text-[#FDFBF7]"
            data-testid="footer-order-link"
          >
            Start an Order
          </button>
          <p className="mt-3 text-xs font-light text-[#FDFBF7]/45">
            Every order is confirmed personally by email.
          </p>
          <p className="mt-1 text-xs font-light text-[#FDFBF7]/45">
            &copy; 2026 Makie&rsquo;s Majestic Kreations
          </p>
        </div>
      </div>
    </footer>
  );
}
